import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import NoDataPlaceHolder from "components/common/NoDataPlaceHolder";
import { useBusinessContext } from "../../../BusinessApp";

function MoneyLine({ color, text, total = 0, last }) {
  const { currencyFormat } = useBusinessContext();
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{currencyFormat(total)}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartSubcategory({
  SubcategorySummary,
  loadingSubCategories,
  secondGraph,
}) {
  const { t } = useTranslation();
  const data = [];

  const other = {
    name: t("general.others"),
    value: 0,
    color: `${Colors.primary_web_color1}`,
    background: `${Colors.primary_web_color1}15`,
  };

  const subcategoriesToShow = 3;
  let shownSubcategories = 0;

  SubcategorySummary.forEach((item) => {
    if (
      item._id?.subcategoryName !== "-" &&
      item._id?.subcategoryName !== null
    ) {
      if (shownSubcategories < subcategoriesToShow) {
        shownSubcategories++;
        data.push({
          name: item._id?.subcategoryName || item.name,
          value: item.sales,
          color:
            shownSubcategories === 1
              ? Colors.text_on_primary
              : Colors.text_primary,
          background:
            shownSubcategories === 1
              ? `${Colors.primary_web}`
              : shownSubcategories === 2
              ? `${Colors.primary_web_color1}70`
              : `${Colors.primary_web_color1}50`,
        });
      } else {
        other.value += parseFloat(item.total).toFixed(2);
      }
    }
  });

  if (other.value > 0) {
    data.push(other);
  }

  return (
    <s.Container>
      <s.Title>
        {t("components.ReportsSalesByCategoryReport.bestSellingSubcategories")}
      </s.Title>
      {!loadingSubCategories ? (
        <>
          {SubcategorySummary.length > 0 ? (
            <div ref={secondGraph}>
              <s.BodyContainer>
                <s.body>
                  <s.LeftBodyContainer>
                    {data.map((item, index) => {
                      if (index > 3) return null;
                      return (
                        <MoneyLine
                          key={index}
                          color={
                            index === 0
                              ? `${Colors.primary_web}`
                              : index === 1
                              ? `${Colors.primary_web_color1}90`
                              : index === 2
                              ? `${Colors.primary_web_color1}40`
                              : `${Colors.primary_web_color1}15`
                          }
                          text={item?.name}
                          total={item?.value}
                        />
                      );
                    })}
                  </s.LeftBodyContainer>
                </s.body>
                <s.pieChartContainer>
                  <PieChartCustom data={data} />
                </s.pieChartContainer>
              </s.BodyContainer>
            </div>
          ) : (
            <NoDataPlaceHolder height="260px" />
          )}
        </>
      ) : (
        <Loading height="260px" size="middle" />
      )}
    </s.Container>
  );
}

export default PieChartSubcategory;
